import { Box, Skeleton } from '@mui/material';

const PublishHistorySkeleton = () => {
  // Create skeleton rows for the table
  const skeletonRows = Array.from({ length: 5 }, (_, index) => (
    <Box
      key={index}
      sx={{
        display: 'flex',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          fontSize: '14px',
          py: 2,
          px: 2,
          width: '20%',
        }}
      >
        <Skeleton variant="text" width="80%" height={20} />
      </Box>
      <Box
        sx={{
          fontSize: '14px',
          py: 2,
          px: 2,
          width: '20%',
        }}
      >
        <Skeleton variant="text" width="90%" height={20} />
      </Box>
      <Box
        sx={{
          fontSize: '14px',
          py: 2,
          px: 2,
          width: '20%',
        }}
      >
        <Skeleton variant="text" width="70%" height={20} />
      </Box>
      <Box
        sx={{
          fontSize: '14px',
          py: 2,
          px: 2,
          width: '20%',
        }}
      >
        <Skeleton variant="text" width="60%" height={20} />
      </Box>
      <Box
        sx={{
          fontSize: '14px',
          py: 2,
          px: 2,
          width: '20%',
        }}
      >
        <Skeleton
          variant="rectangular"
          width={80}
          height={24}
          sx={{ borderRadius: '4px' }}
        />
      </Box>
    </Box>
  ));

  return (
    <Box
      sx={{
        border: '1px solid rgba(224, 224, 224, 1)',
        borderRadius: '8px',
        overflow: 'hidden',
        mx: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          bgcolor: '#F5F9FC',
          height: '40px',
          borderBottom: '1px solid rgba(224, 224, 224, 1)',
        }}
      >
        <Box
          sx={{
            width: '20%',
            fontSize: '14px',
            fontWeight: 600,
            color: 'custom.textBlue',
            py: 1,
            px: 2,
          }}
        >
          Run ID
        </Box>
        <Box
          sx={{
            width: '20%',
            fontSize: '14px',
            fontWeight: 600,
            py: 1,
            px: 2,
          }}
        >
          Title
        </Box>
        <Box
          sx={{
            width: '20%',
            fontSize: '14px',
            fontWeight: 600,
            py: 1,
            px: 2,
          }}
        >
          Start Time
        </Box>
        <Box
          sx={{
            width: '20%',
            fontSize: '14px',
            fontWeight: 600,
            py: 1,
            px: 2,
          }}
        >
          End Time
        </Box>
        <Box
          sx={{
            width: '20%',
            fontSize: '14px',
            fontWeight: 600,
            py: 1,
            px: 2,
          }}
        >
          Status
        </Box>
      </Box>
      <Box>{skeletonRows}</Box>
    </Box>
  );
};

export default PublishHistorySkeleton;
